import { DSButton } from "@components/design-system/molecules";
import { useEffect, useRef, useState } from "react";

import ottoRocket from "../../../assets/imgs/onboarding/otto-in-rocket.png";
import moon from "../../../assets/imgs/onboarding/scribbles-on-the-moon.png";
import styles from "../Onboarding.module.css";

const WelcomeStep = ({
  onRemindMeLater,
  onGetStarted,
  invitedTeamName,
}) => {
  const [isRocketLaunching, setIsRocketLaunching] = useState(false);

  const launchTimeoutRef = useRef(null);

  const handleGetStarted = () => {
    setIsRocketLaunching(true);
    if (launchTimeoutRef.current) {
      clearTimeout(launchTimeoutRef.current);
    }

    // Only run the timeout if the rocket is visible (from tailwind's md screens and larger)
    const isRocketVisible = window.innerWidth >= 768;

    if (isRocketVisible) {
      launchTimeoutRef.current = setTimeout(() => {
        onGetStarted();
      }, 2000);
    } else {
      onGetStarted();
    }
  };

  useEffect(() => {
    return () => {
      if (launchTimeoutRef.current) {
        clearTimeout(launchTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div className={styles.container}>
      <div className="text-center mt-[40vh]">
        <h1
          className="text-3xl md:text-4xl text-white"
          data-testid="welcome-title"
        >
          Welcome to the Academy, Scribenaut!
        </h1>
        <h2 className="mt-4 text-lg md:text-xl text-white font-semibold">
          {invitedTeamName
            ? `You have been invited to Scribenote by ${invitedTeamName}!`
            : `Do you have 5 minutes to learn how to use Scribenote?`}
        </h2>
        <div className="flex flex-col justify-center mt-16 space-y-4 max-w-2xl mx-auto">
          <DSButton
            variant="primary"
            size="lg"
            dataTestId="get-started-button"
            onClick={handleGetStarted}
          >
            {invitedTeamName
              ? `Let's get started`
              : `Yes! Let's get started.`}
          </DSButton>
          <DSButton
            variant="secondary"
            size="lg"
            dataTestId="remind-me-later-button"
            onClick={onRemindMeLater}
          >
            Remind me later
          </DSButton>
        </div>
      </div>
      <img
        src={moon}
        alt="Scribbles on the Moon"
        className={styles.moon}
        draggable={false}
      />
      <img
        src={ottoRocket}
        alt="Otto in Rocket"
        className={`${styles.rocket} ${
          isRocketLaunching && styles.rocketLaunch
        } hidden md:block`}
        draggable={false}
      />
    </div>
  );
};

export default WelcomeStep;
